import React from 'react';
import * as logger from '@happyreturns/jscommons';
import Icon from '../icons';
import { getColor, PrimaryButton } from '../utility';
import PropTypes from 'prop-types';

function ErrorBox(props) {
  function renderMessage() {
    let text = 'This tracking link isn’t associated with';

    if (props.returnMode) {
      text += ' a return.';
    } else {
      text += ' an order.';
    }

    if ((STYLES || {}).contact_url) {
      text +=
        ' Please review your link and try again or click below to contact us.';
    } else {
      text += ' Please review your link.';
    }

    return <div className="error-text error-content-item "> {text} </div>;
  }

  function renderContactButton() {
    return (
      <div className="flex-row">
        <div
          className="button error-content-item"
          onClick={() => {
            logger.Info("User clicked 'Contact Us' button on error page");
            window.open((STYLES || {}).contact_url, '_blank');
          }}
        >
          <div style={{ paddingTop: '10px' }}>
            <div className="button-text">Contact Us</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="error-box">
      <div className="search-icon error-content-item">
        <Icon fill={getColor('grayish')} name="search" />
      </div>
      <div className="error-header error-content-item ">
        {props.returnMode
          ? "Return status can't be found"
          : "Delivery status can't be found"}
      </div>
      {renderMessage()}
      {(STYLES || {}).contact_url && renderContactButton()}
    </div>
  );
}
ErrorBox.propTypes = {
  // when this is true, show messaging appropriate for when the customer
  // is returning a package to a retailer
  returnMode: PropTypes.bool.isRequired,
};

export default ErrorBox;
